import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Col, FormGroup, Label, Row } from 'reactstrap';
import ButtonSection from '../ProjectCreate/ButtonSection';
import api from '../../../../utils/api';
import Swal from 'sweetalert2';
import { useEffect } from 'react';

const StaffRegisterForm = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: '',
    mailId: '',
    userName: 'staff',
    phoneNumber: '',
    password: '',
    staffPost: '',
    staffAddress: '',
    staffGender: '',
    staffDOB: '',
    staffDepartment: '',
    reportingManager: '',
    role: 'Staff',
    counterid: '',
    customerName: '',
  });

  const [counterAll, setCounterAll] = useState([]);

    const getAllCounter = async () => {
        try{
        const response = await api.get('api/CounterMaster/GetAllCounters'); 
        if (response.status === 200) {
            const counters = response.data;
            console.log("all counter", counters)
            setCounterAll(counters);
        }
        } catch(error){
        console.error("Failed to fetch counters:");
        }
    }

  useEffect(() => {
    getAllCounter();
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const payload = {
        name: formData.name,
        mailId: formData.mailId,
        userName: formData.mailId,
        phoneNumber: formData.phoneNumber,
        password: formData.password,
        staffPost: formData.staffPost,
        staffAddress: formData.staffAddress,
        staffGender: formData.staffGender,
        staffDOB: formData.staffDOB,
        staffDepartment: formData.staffDepartment,
        reportingManager: formData.reportingManager,
        role: 'Staff',
        counterid: formData.counterid
    };
    if (
      payload.name === '' ||
      payload.phoneNumber === '' ||
      payload.password === '' ||
      payload.staffPost === '' ||
      payload.staffAddress === '' ||
      payload.staffGender === '' ||
      payload.staffDOB === '' ||
      payload.staffDepartment === '' ||
      payload.reportingManager === '' ||
      payload.role === '' ||
      payload.counterid === ''
    ) {
      Swal.fire({
        icon: 'warning',
        title: 'Invalid Input',
        text: 'Please enter valid details.',
      });
      return;
    }
    if (!payload.phoneNumber || !payload.password || !payload.counterid) {
      Swal.fire({
        icon: 'warning',
        title: 'Missing Fields',
        text: 'Please fill in all required fields.',
      });
      return;
    }
    if (!/^\d{10}$/.test(payload.phoneNumber)) {
      Swal.fire({
        icon: 'warning',
        title: 'Invalid Mobile Number',
        text: 'Please enter a valid 10-digit mobile number.',
      });
      return;
    }

    try {
        const response = await api.post('/api/Auth/StaffRegistration', payload, {
          headers: {
            'Content-Type': 'application/json',
          }
        });
    
        if (response.status === 200 || response.status === 201) {
          Swal.fire({
            icon: 'success',
            title: 'Success!',
            text: response.data.status,
          }).then(() => {
            navigate(`${process.env.PUBLIC_URL}/staffs/all-staffs`);
          });
        } else {
          Swal.fire({
            icon: 'warning',
            title: 'Unexpected Response',
            text: 'Please try again later.',
          });
        }
    } catch (error) {
        Swal.fire({
            icon: 'error',
            title: 'Submission Failed',
            text: 'Something went wrong while staff registration.',
        });
    }
  };

  return (
    <form onSubmit={handleSubmit} className="theme-form">
      <Row>
        <Col sm="4">
          <FormGroup>
            <Label>
              Name<span className="text-danger ml-1">*</span>
            </Label>
            <input
              name="name"
              type="text"
              className="form-control"
              placeholder="Enter staff name..."
              value={formData.name || ""}
              required={true}
              onChange={handleChange}
            />
          </FormGroup>
        </Col>
        <Col sm="4">
          <FormGroup>
            <Label>Mail ID</Label>
            <input
              name="mailId"
              type="email"
              className="form-control"
              placeholder="Enter mail ID..."
              value={formData.mailId || ""}
              required={true}
              onChange={handleChange}
            />
          </FormGroup>
        </Col>
        {/* <Col sm="4">
        <FormGroup>
        <Label>User Name</Label>
        <input
          name="userName"
          type="text"
          className="form-control"
          placeholder="Enter user name..."
          value={formData.userName || ''}
          required={true}
          onChange={handleChange}
        />
        </FormGroup>
      </Col> */}
        <Col sm="4">
          <FormGroup>
            <Label>
              Phone Number<span className="text-danger ml-1">*</span>
            </Label>
            <input
              name="phoneNumber"
              type="text"
              className="form-control"
              placeholder="Enter phone number..."
              value={formData.phoneNumber || ""}
              required={true}
              onChange={handleChange}
            />
          </FormGroup>
        </Col>
        <Col sm="4">
          <FormGroup>
            <Label>
              Password<span className="text-danger ml-1">*</span>
            </Label>
            <input
              name="password"
              type="password"
              className="form-control"
              placeholder="Enter password..."
              value={formData.password || ""}
              required={true}
              onChange={handleChange}
            />
          </FormGroup>
        </Col>
        <Col sm="4">
          <FormGroup>
            <Label>
              Counter<span className="text-danger ml-1">*</span>
            </Label>
            <select
              name="counterid"
              className="form-control"
              value={formData.counterid || ""}
              required={true}
              onChange={handleChange}
            >
              <option value="">Select Counter</option>

              {counterAll
                .filter((counter: any) => counter.counterId !== 1010)
                .map((counter: any) => (
                  <option key={counter.counterId} value={counter.counterId}>
                    {counter.counterName}
                  </option>
                ))}
            </select>
          </FormGroup>
        </Col>
        <Col sm="4">
          <FormGroup>
            <Label>
              Staff Post<span className="text-danger ml-1">*</span>
            </Label>
            <input
              name="staffPost"
              type="text"
              className="form-control"
              placeholder="Enter staff post..."
              value={formData.staffPost || ""}
              required={true}
              onChange={handleChange}
            />
          </FormGroup>
        </Col>
        <Col sm="4">
          <FormGroup>
            <Label>
              Staff Address<span className="text-danger ml-1">*</span>
            </Label>
            <textarea
              name="staffAddress"
              className="form-control"
              placeholder="Enter staff address..."
              value={formData.staffAddress || ""}
              required={true}
              onChange={handleChange}
            ></textarea>
          </FormGroup>
        </Col>
        <Col sm="4">
          <FormGroup>
            <Label>
              Staff Gender<span className="text-danger ml-1">*</span>
            </Label>
            <select
              name="staffGender"
              className="form-control"
              value={formData.staffGender || ""}
              required={true}
              onChange={handleChange}
            >
              <option value="">Select Gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </select>
          </FormGroup>
        </Col>
        <Col sm="4">
          <FormGroup>
            <Label>
              Staff DOB<span className="text-danger ml-1">*</span>
            </Label>
            <input
              name="staffDOB"
              type="date"
              className="form-control"
              value={formData.staffDOB || ""}
              required={true}
              onChange={handleChange}
            />
          </FormGroup>
        </Col>
        <Col sm="4">
          <FormGroup>
            <Label>
              Staff Department<span className="text-danger ml-1">*</span>
            </Label>
            <input
              name="staffDepartment"
              type="text"
              className="form-control"
              placeholder="Enter staff department..."
              value={formData.staffDepartment || ""}
              required={true}
              onChange={handleChange}
            />
          </FormGroup>
        </Col>
        <Col sm="4">
          <FormGroup>
            <Label>
              Reporting Manager<span className="text-danger ml-1">*</span>
            </Label>
            <input
              name="reportingManager"
              type="text"
              className="form-control"
              placeholder="Enter reporting manager..."
              value={formData.reportingManager || ""}
              required={true}
              onChange={handleChange}
            />
          </FormGroup>
        </Col>
        <Col sm="4">
          <FormGroup>
            <Label>
              Role<span className="text-danger ml-1">*</span>
            </Label>
            <input
              name="role"
              type="text"
              readOnly={true}
              className="form-control"
              placeholder="Enter role..."
              value={formData.role || ""}
              required={true}
              onChange={handleChange}
            />
          </FormGroup>
        </Col>
      </Row>
      <ButtonSection cancel_url={`/staffs/all-staffs`} />
    </form>
  );
};

export default StaffRegisterForm;
